export default "__VITE_ASSET__D86EKS7p__"